"use client";

import { ThemeProvider } from "@components/theme-provider";
import { NavigationMenuDemo } from "@components/layout/main-nav";
import { Search } from "lucide-react";
import { UserNav } from "@components/layout/user-nav";
import { ModeToggle } from "@components/layout/mode-toggle";
import { Toaster } from "sonner";
import { Providers } from "@admin/store/provider";
import SessionLocalProvider from "@admin/store/session-provider";
import { usePathname } from 'next/navigation';

export default function ClientLayout({
    children,
}: {
    children: React.ReactNode;
}) {
    const pathname = usePathname();
    const isLoginPage = pathname === '/login';

    return (
        <SessionLocalProvider>
            <Providers>
                <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
                    {isLoginPage ? (
                        children
                    ) : (
                        <div className="flex-col">
                            <div className="border-b">
                                <div className="flex h-16 items-center px-4">
                                    <NavigationMenuDemo />
                                    <div className="ml-auto flex items-center space-x-4">
                                        <Search />
                                        <UserNav />
                                        <ModeToggle />
                                    </div>
                                </div>
                            </div>
                            <div className="mx-4 mt-10 mb-4">{children}</div>
                        </div>
                    )}
                    <Toaster richColors />
                </ThemeProvider>
            </Providers>
        </SessionLocalProvider>
    );
} 